export class GuestTestDataProvider {
    startTest(data) {
        return axios.post('/rest/tests/attempt', data);
    }

    answer(data) {
        return axios.post('/rest/tests/attempt/answer', data);
    }

    finish(data) {
        return axios.post('/rest/tests/attempt/finish', data);
    }

    getTestResult(data) {
        return axios.post('/rest/tests/attempt/result', data);
    }

    getTestPass(data) {
        return axios.get(`/rest/tests/pass/${data.testId}`);
    }

    getTestAttempt(data) {
        throw new Error('Not implemented');
    }
}
